const TERMINAL_STATUSES = ['COMPLETED', 'FAILED']

class UploadFile {
  constructor (raw = {}) {
    this.filename = raw.filename || ''
    this.s3Key = raw.s3_key || ''
    this.presignedUrl = raw.presigned_url || ''
    this.status = raw.status || ''
  }
}

export default class ClientFileUpload {
  constructor (raw = {}) {
    this.id = raw.id || raw.upload_id || ''
    this.type = raw.type || ''
    this.bucket = raw.bucket || ''
    this.s3Prefix = raw.s3_prefix || ''
    this.files = (raw.files || []).map(f => new UploadFile(f))
    this.status = raw.status || ''
    this.progress = (typeof raw.progress === 'number' && raw.progress >= 0) ? Math.min(Math.round(raw.progress), 100) : 0
    this.result = raw.result || null
    this.parameters = raw.parameters || {}
    this.clientId = raw.client_id || ''
    this.createdBy = raw.created_by || ''
    this.createdAt = raw.created_at || ''
    this.modifiedAt = raw.modified_at || ''
  }

  get isTerminal () {
    return TERMINAL_STATUSES.includes(this.status)
  }

  get isCompleted () {
    return this.status === 'COMPLETED'
  }

  get isFailed () {
    return this.status === 'FAILED'
  }

  get progressPercent () {
    return this.progress
  }

  get progressLabel () {
    if (this.isCompleted) return 'Completado'
    if (this.isFailed) return 'Error'
    if (this.progress >= 100) return 'Finalizando…'
    return `${this.progress}% completado`
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/models/ClientFileUpload.js